var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    width: 40,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "m 571.76954,260.61914 a 42.041302,42.041302 0 0 1 30.2832,10.875 42.041302,42.041302 0 0 1 2.8457,59.38867 L 394.75586,562.17969 a 42.041302,42.041302 0 0 1 -59.38867,2.8457 42.041302,42.041302 0 0 1 -2.8457,-59.38672 L 542.66602,274.33984 a 42.041302,42.041302 0 0 1 29.10352,-13.7207 z",
    id: "path298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "m 574.43164,260.57031 a 42.041302,42.041302 0 0 1 42.04102,42.04102 42.041302,42.041302 0 0 1 -42.04102,42.04101 H 26.785161 a 42.041302,42.041302 0 0 1 -42.04102,-42.04101 42.041302,42.041302 0 0 1 42.04102,-42.04102 z",
    id: "path908"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "m 365.65039,29.320312 a 42.041302,42.041302 0 0 1 29.10547,13.722657 L 604.89844,274.33984 a 42.041302,42.041302 0 0 1 -2.8457,59.38868 42.041302,42.041302 0 0 1 -59.38672,-2.84571 L 332.52149,99.585937 a 42.041302,42.041302 0 0 1 2.8457,-59.388671 42.041302,42.041302 0 0 1 30.2832,-10.876954 z",
    id: "path910"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowRight);
export default __webpack_public_path__ + "static/media/ico-arrow-right.1a8b4ce2.svg";
export { ForwardRef as ReactComponent };